export interface OverpaymentSummary {
  reasons: string;
  source: string;
  from: Date;
  through: Date;
  recoveryClaim: string;
  altFileUid: number;
  altFileNum: string;
  overpaid: number;
  recovered: number;
  balance: number;
  masterGroupId: number;
  detailCount: number;
}

export class OverpaymentTotals {
  overpaid: number;
  recovered: number;
  balance: number;

  get totalPercent(): number {
    if (this.overpaid > 0) {
      const percent = (this.recovered / this.overpaid) * 100;
      return Math.min(percent, 100);
    }
    return 0;
  }
}
